import React, { useEffect, useState } from "react";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { CircularProgress } from "@mui/material";

const EntityModal = ({
  show,
  handleClose,
  customerCode,
  name,
  entityDetails,
  modalType,
  handleShowTable,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [entityId, setEntityId] = useState("");
  const [entityName, setEntityName] = useState("");
  const [entityIdError, setEntityIdError] = useState("");
  const [entityNameError, setEntityNameError] = useState("");
  const [loading, setLoading] = useState(false);

  const isReadOnly = !!entityDetails;

  const handleAddEntity = async (e) => {
    e.preventDefault();

    let isValid = true;
    // Validate Entity ID
    if (!entityId) {
      setEntityIdError("Entity ID is required");
      isValid = false;
    } else if (!/^[1-9][0-9]{5,18}$/.test(entityId)) {
      setEntityIdError(
        "Entity ID must be 6 to 19 digits and cannot start with 0"
      );
      isValid = false;
    } else if (!/^[0-9]+$/.test(entityId)) {
      setEntityIdError("Entity ID must contain digits only (0-9)");
      isValid = false;
    } else if (/^(\d)\1+$/.test(entityId)) {
      setEntityIdError("Entity ID cannot be the same digit repeated");
      isValid = false;
    } else {
      setEntityIdError("");
    }

    // Validate Entity Name
    if (!entityName) {
      setEntityNameError("Entity Name is required");
      isValid = false;
    } else if (entityName.length < 5 || entityName.length > 60) {
      setEntityNameError("Entity Name must be 5 to 60 characters long");
      isValid = false;
    // } else if (!/^[A-Za-z0-9 ]+$/.test(entityName)) {
    //   setEntityNameError(
    //     "Entity Name can only contain letters, numbers, and spaces"
    //   );
    //   isValid = false;
    } else if (/^\s|\s$/.test(entityName)) {
      setEntityNameError("Entity Name cannot start or end with spaces");
      isValid = false;
    } else if (/\s{2,}/.test(entityName)) {
      setEntityNameError("Entity Name cannot have multiple consecutive spaces");
      isValid = false;
    } else if (/^(\d)\1+$/.test(entityName)) {
      setEntityNameError("Entity Name cannot be the same digit repeated");
      isValid = false;
    } else {
      setEntityNameError("");
    }

    if (!isValid) return;

    const data = {
      username: loggedInUserName,
      entityId: entityId,
      userCode: customerCode,
      entityName: entityName,
    };

    try {
      const response = await axiosPostApi(apiList.DLT_ADD_ENTITY, data);

      if (response?.status === 200 && response?.data?.status === true) {
        toast.success("Entity added successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose();
        handleBack();
      } else {
        CustomAlert({
          title: "Failed to Add Entity",
          text:
            response.data.message ||
            "There was an issue processing the request. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      toast.error("Failed to add entity. Please try again.");
    }
  };

  const handleBack = () => {
    if (modalType !== "modify") {
      setEntityName("");
    }
    handleClose();
    setEntityId("");
    setEntityIdError("");
    setEntityNameError("");
  };

  const handleModifyData = async (entity) => {
    if (!entityName) {
      setEntityNameError("Entity Name is required");
      return;
    }

    setEntityIdError("");

    const data = {
      username: loggedInUserName,
      entityId: entityDetails?.id,
      entityName,
    };
    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.MODIFY_DATA, data);
      if (response?.status === 200) {
        toast.success("Entity Name Update Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose();
        handleShowTable();
        handleBack();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    modalType === "modify" ? handleModifyData() : handleAddEntity(e);
  };

  useEffect(() => {
    if (modalType === "modify") {
      setEntityName(entityDetails?.name);
    }
  }, [modalType, entityDetails?.name]);

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: "#f2f1f7" }}>
            <div className="">
              <h5 className="modal-title main-title">
                {" "}
                {modalType === "view"
                  ? "View Entity Details"
                  : modalType === "modify"
                  ? "Modify Entity Details"
                  : "Add Entity ID"}
              </h5>
              {!isReadOnly && (
                <p className="modal-subtitle m-0" style={{ fontSize: "14px" }}>
                  Add new Entity ID by filling the details below
                </p>
              )}
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleBack}
            ></button>
          </div>
          <form onSubmit={handleFormSubmit}>
            <div className="scoped-modal modal-body">
              <div className="mb-3">
                <label htmlFor="entityName" className="form-label">
                  Entity Name<span style={{ color: "#DC3545" }}>*</span>
                </label>
                <input
                  type="text"
                  id="entityName"
                  className="form-control"
                  placeholder="Enter Entity Name"
                  value={
                    modalType === "view"
                      ? entityDetails?.name
                      : modalType === "modify"
                      ? entityName
                      : entityName
                  }
                  onChange={(e) => setEntityName(e.target.value)}
                  autoComplete="off"
                  readOnly={modalType === "view"}
                />
                {entityNameError && modalType !== "view" && (
                  <div className="text-danger">{entityNameError}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="entityId" className="form-label">
                  Entity ID
                  <span style={{ color: "#DC3545" }}>*</span>
                </label>
                <input
                  type="text"
                  id="entityId"
                  className="form-control"
                  placeholder="Enter Entity ID"
                  value={isReadOnly ? entityDetails?.id : entityId}
                  onChange={(e) => setEntityId(e.target.value)}
                  readOnly={isReadOnly}
                  autoComplete="off"
                  style={{ cursor: isReadOnly ? "not-allowed" : "auto" }}
                />
                {entityIdError && (
                  <div className="text-danger">{entityIdError}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-back"
                onClick={handleBack}
              >
                Back
              </button>
              {(modalType === "modify" && modalType !== "view") ||
              !modalType ? (
                <button type="submit" className="btn btn-submit">
                  {loading ? (
                    <CircularProgress
                      className="circular-loader"
                      style={{ width: "20px", height: "20px" }}
                    />
                  ) : modalType === "modify" ? (
                    "Update"
                  ) : modalType === "view" ? null : (
                    "Add"
                  )}
                </button>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EntityModal;
